import {
    AccountMappingAccountItem,
    AccountMappingTemplateGroupItem,
    IAccountMappingSubFLI,
    IAccountMappingTemplateGroup,
    IAccountMappingTemplateGroupItemFLI,
    IAccountMappingTemplateGroupItemSubtotal,
} from '@modeso/types__aumico-lib-annualreport-be';
import { MenuAction } from '../enums/menu-action.enum';

export class MenuItem {
    icon: string;
    name: string;
    action: MenuAction;
    disabled: boolean;
}

export type Item =
    | AccountMappingAccountItem
    | IAccountMappingTemplateGroup
    | AccountMappingTemplateGroupItem
    | IAccountMappingTemplateGroupItemSubtotal;
export type Parent = IAccountMappingTemplateGroup | IAccountMappingTemplateGroupItemFLI | IAccountMappingSubFLI;
